import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import About from '../about/About';
import BlogMenu from '../blog/BlogMenu';
import HomeCountyBubbleMap from '../home/HomeCountyBubbleMap';
import HomeCountyExplorer from '../home/HomeCountyExplorer';
import HomeLeaderboardWidget from '../home/HomeLeaderboardWidget';
import HomeMemberClubs from '../home/HomeMemberClubs';
import HomeRandomCard from '../home/HomeRandomCard';
import Faqs from '../faqs/Faqs';
import Membership from '../membership/Membership';

//import EnglandEmoji from "../../img/flags/England_emoji_20_12.png";

export default function CompareMenu() {
  const navigate = useNavigate();
  const [countyStats, setCountyStats] = useState(null);

  const handleJoinClubClick = () => {
    navigate('/register');
  };

  const handleSearchLists = () => {
    navigate('/lists/golf-courses/rankings');
  };

  return (
    <>
      <section className="w-full">
        <div className="w-11/12 mx-auto my-6 sm:my-8">
          <div className="mb-4 sm:mb-6 bg-white rounded-2xl shadow-xl shadow-slate-200/60 ring-1 ring-slate-200/80 p-5 sm:p-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div>
                <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
                  Data-led views of UK & Ireland golf courses and clubs
                </h1>
                <p className="mt-1 text-sm sm:text-base text-slate-600 max-w-3xl">
                  Explore county rankings, interactive maps, green fee benchmarks, architect insights, and community stats — built for golfers who like details.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 sm:min-w-[340px]">
                <button
                  onClick={handleSearchLists}
                  className="w-full bg-slate-900 text-white font-semibold rounded-xl py-3 px-6 shadow-md hover:bg-slate-800 transition-colors"
                >
                  Explore rankings
                </button>
                <button
                  onClick={handleJoinClubClick}
                  className="w-full bg-indigo-600 text-white font-semibold rounded-xl py-3 px-6 shadow-md hover:bg-indigo-500 transition-colors"
                >
                  Join for free
                </button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
          <div className="xl:col-span-8 order-1">
            <HomeCountyBubbleMap countiesByCountry={countyStats?.byCountry || {}} />
          </div>
          <div className="xl:col-span-4 order-2">
            <HomeLeaderboardWidget />
          </div>
          <div className="xl:col-span-12 order-3">
            <HomeCountyExplorer onData={setCountyStats} />
          </div>
          </div>
        </div>
      </section>
      <hr></hr>
      <HomeMemberClubs />
      <hr></hr>
      <About />
      <hr></hr>
      <Membership level={2} />
      <hr></hr>
      <HomeRandomCard />
      <hr></hr>

      <BlogMenu numberOfPosts={3} level={2} />

      <hr></hr>
      <Faqs level={2} />
      <hr></hr>
    </>
  );
}
